export async function decodeGzip(bytes: ArrayBuffer): Promise<ArrayBuffer> {
  const signature = new Uint8Array(bytes, 0, Math.min(2, bytes.byteLength));
  // Some servers send .gz files with `Content-Encoding`, so fetch has already decoded them.
  // Others send the raw gzip file. Check the magic bytes so nothing gets decompressed twice.
  if (signature[0] !== 0x1f || signature[1] !== 0x8b) return bytes;
  return new Response(
    new Blob([bytes]).stream().pipeThrough(new DecompressionStream("gzip")),
  ).arrayBuffer();
}
